export interface NavItem {
  label: string;
  href: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: "Início", href: "/" },
  { label: "Notícias", href: "/noticias" },
  { label: "Cursos", href: "/cursos" },
  { label: "Ferramentas", href: "/ferramentas" },
  { label: "Sobre", href: "/sobre" },
];
